import { ofType } from 'redux-observable';
import type { Observable } from 'rxjs';
import { ignoreElements, withLatestFrom } from 'rxjs/operators';
import type { ILogAnalytics } from 'shared/middlewares/analytics/logger';
import type { SpEpic } from 'shared/middlewares/epic/epicMiddleware.factory';
import type { MatomoStarted } from 'state/userConsent/userConsent.actions';

export function changeAnalyticsUserConsentEpic(analytics: ILogAnalytics): SpEpic {
  return action$ => {
    const started$: Observable<MatomoStarted> = action$.pipe(ofType('MATOMO_STARTED'));
    return action$.pipe(
      ofType('MATOMO_USER_CONSENT_CHANGED'),
      withLatestFrom([started$], ({ consent }, _) => {
        analytics.changeUserConsent(consent);
        return consent;
      }),
      ignoreElements(),
    );
  };
}
